<template>
  <div>
    <el-menu v-if="screenWidth > 1080" :default-active="activeIndex2" class="custom-menu" mode="horizontal" @select="handleSelect"
      background-color="#2D9854" text-color="#fff" active-text-color="#fff">
      <el-menu-item index="1"><span class="title-no-rem">首页</span></el-menu-item>
      <el-menu-item index="2"><span class="title-no-rem">关于欧力泰</span></el-menu-item>
      <el-menu-item index="3"><span class="title-no-rem">明星产品</span></el-menu-item>
      <el-menu-item index="4"><span class="title-no-rem">新闻动态</span></el-menu-item>
      <el-menu-item index="5"><span class="title-no-rem">联系我们</span></el-menu-item>
    </el-menu>
  </div>
</template>
<script>
export default {
  name: "Menu",
  props: ['screenWidth'],
  data() {
    return {
      activeIndex2: this.$route.query.activeIndex ? this.$route.query.activeIndex : '1',
    }
  },
  methods: {
    handleSelect(key, keyPath) {
      console.log('key==', key)
      if (key === '1' && this.$route.query.activeIndex !== key) {
        this.$router.push({ path: '/', query:{activeIndex: key} })
      }else if(key === '2' && this.$route.query.activeIndex !== key){
        this.$router.push({ path: '/olt', query:{activeIndex: key} })
      } else if (key === '3' && this.$route.query.activeIndex !== key) {
        this.$router.push({ path: '/star', query:{activeIndex: key} })
      }else if(key === '4' && this.$route.query.activeIndex !== key){
        this.$router.push({ path: '/news', query:{activeIndex: key} })
      } else if (key === '5' && this.$route.query.activeIndex !== key) {
        this.$router.push({ path: '/contact', query:{activeIndex: key} })
      }
      this.activeIndex2 = key;
    },
  }
}
</script>
<style scoped lang="scss">
::v-deep .el-menu.el-menu--horizontal {
  border-bottom: none;
}

.title-no-rem{
  font-size: 17px;

}

.custom-menu {
  display: flex;
  justify-content: space-around;
  /* 平分空间 */
  align-items: center;
  /* 垂直居中 */
}

.custom-menu .el-menu-item {
  width: 165px;
  text-align: center;
  /* 文本居中 */
}
</style>
